import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { registerUser, getFrontendErrorMessage } from "../../utils/fireStoreFunction"; // Corrected path
import "../../style/authentication.css"; // Corrected path

export default function Register() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [name, setName] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(false);

    const handleSignUp = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            if (!/^[a-zA-Z]/.test(email)) {
                setErrorMessage("The email must start with a letter.");
                setLoading(false);
                return;
              }
              
              const emailRegex = /^[a-zA-Z0-9._%+-]+@gmail\.com$/;
              if (!emailRegex.test(email)) {
                setErrorMessage("The email must be a valid Gmail address (e.g., example@gmail.com).");
                setLoading(false);
                return;
              }
              
              if (name === "" ||  !/^[a-zA-Z][a-zA-Z0-9\s]*$/.test(name) ||  name.length < 3) {
                setErrorMessage("Name cannot be empty, must contain only letters, and be at least 3 characters long.");
                setLoading(false);
                return;
              }

            if (password.length < 6) {
                setErrorMessage("Password is too weak. It should be at least 6 characters long.");
                setLoading(false);
                return;
            }

            const res = await registerUser(name, email, password);
            if (res.success) {
                navigate("/");
            } else {
                const errorMsg = getFrontendErrorMessage(res.error);
                setErrorMessage(errorMsg);
            }
        } catch (error) {
            setErrorMessage("An unexpected error occurred.");
        }
        setLoading(false);
    };

    return (
        <form onSubmit={handleSignUp}>
            <div className="form-group">
                <input
                    type="text"
                    id="input_form"
                    placeholder="Your Name"
                    autoComplete="off"
                    onChange={(e) => setName(e.target.value)}
                    required
                />
                <i className="input-icon material-icons">perm_identity</i>
            </div>
            <div className="form-group">
                <input
                    type="email"
                    id="input_form"
                    placeholder="Your Email"
                    autoComplete="off"
                    onChange={(e) => setEmail(e.target.value)}
                    required
                />
                <i className="input-icon material-icons">alternate_email</i>
            </div>
            <div className="form-group">
                <input
                    type="password"
                    id="input_form"
                    placeholder="Your Password"
                    autoComplete="off"
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
                <i className="input-icon material-icons">lock</i>
                {errorMessage && <p className="handle_text">{errorMessage}</p>}
            </div>
            <button type="submit" className="auth-btn" disabled={loading}>
                {loading ? "Signing Up..." : "Sign Up"}
            </button>
        </form>
    );
}